import { getProfileName, hasMyChartAuthorizedEpicFeature } from './Utils.js';


export function getProfileMenuItems({
    authorizedFeaturesProps,
    Covid19AgeForVaccine,
    currentPharmacyUser,
    currentUser,
    disableMyChartMenuItems,
    EnableProfileDashboard,
    hasAAL,
    hasFirstCare,
    hasHealthPlanLogin,
    hasMyChart,
    hasPharmacyLogin,
    isMyChartProxyUser,
    isMyChartUser,
    isPrimaryUser,
    notPharmacyProxy
}) {

    const profileName = getProfileName({
        hasAAL,
        hasHealthPlanLogin,
        hasFirstCare,
        hasMyChart,
        isMyChartProxyUser,
        currentPharmacyUser,
        hasPharmacyLogin
    });



    return {
        show: notPharmacyProxy,
        navHead: {
            label: profileName,
            url: null,
            icon: 'patient'
        },
        navItems: [
            {
                label: 'Personal Profile',
                show: notPharmacyProxy,
                disabled: (!isPrimaryUser && disableMyChartMenuItems),
                url: '/personalprofilelanding',
                subMenuItems: {
                    menuLabel: "Personal Profile",
                    menuItems: [
                        {
                            label: 'Contact Information',
                            show: notPharmacyProxy,
                            disabled: (!isPrimaryUser && disableMyChartMenuItems),
                            url: '/demographics',
                        },
                        {
                            label: 'Administrative Information',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/admininfo'
                        },
                        {
                            label: 'Wallet Card',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/walletcard'
                        },
                        {
                            label: 'Advance Care Planning & Advance Directives',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/directives'
                        },
                    ]
                },
            },
            {
                label: 'MyBSWHealth Profile',
                show: notPharmacyProxy & EnableProfileDashboard,
                url: '/profiledashboard',
                subMenuItems: null
            },
            {
                label: 'Tests & Procedures',
                show: isMyChartUser,
                disabled: disableMyChartMenuItems,
                url: '/testsprocedureslanding',
                subMenuItems: {
                    menuLabel: 'Tests & Procedures',
                    menuItems: [
                        {
                            label: 'Results',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/testresults',
                        },
                        {
                            label: 'Upcoming',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/upcomingtests'
                        },
                    ]
                },
            },
            {
                label: 'Vaccine Credentials',
                show: isMyChartUser && currentUser && currentUser?.ay >= Covid19AgeForVaccine,
                disabled: disableMyChartMenuItems,
                url: '/vaccinecredentials',
                subMenuItems: null,
            },
            {
                label: 'Medications',
                show: isMyChartUser,
                disabled: disableMyChartMenuItems,
                url: '/currentmeds',
                subMenuItems: null,
            },
            {
                label: 'Health Summary',
                show: isMyChartUser,
                disabled: disableMyChartMenuItems,
                url: '/healthsummarylanding',
                subMenuItems: {
                    menuLabel: 'Health Summary',
                    menuItems: [
                        {
                            label: 'Current Health Issues',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/currentissues',
                        },
                        {
                            label: 'Allergies',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/allergies'
                        },
                        {
                            label: 'Immunizations',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/immunizations'
                        },
                        {
                            label: 'Preventive Care',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/todo',
                            altUrls: ['/healthmaintenance']
                        },
                        {
                            label: 'Medical & Family History',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/medicalhistory'
                        },
                        {
                            label: 'Plan of Care',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/planofcare'
                        },
                    ]
                },
            },
            {
                label: 'Records and Medical Forms',
                show: isMyChartUser,
                disabled: disableMyChartMenuItems,
                url: '/recordsmedicalformslanding',
                subMenuItems:
                {
                    menuLabel: 'Records and Medical Forms',
                    menuItems: [
                        {
                            label: 'Document Center',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/medicalrecord'
                        },
                        {
                            label: "Who’s Accessed My Profile?",
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/audit'
                        },
                        {
                            label: 'Growth Charts',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/growthcharts'
                        },
                        {
                            label: 'Questionnaires',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/questionnaires'
                        },
                        {
                            label: 'Share My Record',
                            show: isMyChartUser,
                            disabled: disableMyChartMenuItems,
                            url: '/shareeverywhere'
                        },
                    ]
                }
            },
            //{
            //     label: 'My Conditions',
            //     show: isMyChartUser && hasMyChartAuthorizedEpicFeature("hasAuthorizedFeatureMyConditions", authorizedFeaturesProps),
            //     url: '/myconditions',
            //     subMenuItems: null,
            //     disabled: disableMyChartMenuItems
            // },
        ]
    };
}